import { useLogout } from "@/hooks/auth-queries";
import {
	CrownOutlined,
	ExclamationCircleOutlined,
	LogoutOutlined,
} from "@ant-design/icons";
import { Alert, Button, Modal, Space, Typography } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

const { Title, Text, Paragraph } = Typography;

interface ExpiredTrialModalProps {
	open: boolean;
	onClose: () => void;
}

export const ExpiredTrialModal: React.FC<ExpiredTrialModalProps> = ({
	open,
	onClose,
}) => {
	const logout = useLogout();
	const navigate = useNavigate();

	const handleLogout = async () => {
		try {
			await logout();
			// The logout hook will handle navigation
		} catch (error) {
			console.error("Logout failed:", error);
		}
	};

	const handleUpgrade = () => {
		// Close the modal and navigate to subscription page
		onClose();
		navigate("/subscription");
	};

	return (
		<>
			<Modal
				title={
					<Space>
						<ExclamationCircleOutlined style={{ color: "#ff4d4f" }} />
						<span>Trial Account Expired</span>
					</Space>
				}
				open={open}
				onCancel={onClose}
				footer={[
					<Button key="logout" size="large" onClick={handleLogout}>
						<LogoutOutlined />
						Logout
					</Button>,
					<Button
						key="upgrade"
						type="primary"
						size="large"
						onClick={handleUpgrade}
					>
						<CrownOutlined />
						Upgrade Now
					</Button>,
				]}
				width={500}
				centered
				closable={false}
				maskClosable={false}
			>
				<div style={{ textAlign: "center", padding: "20px 0" }}>
					<Alert
						message="Your 7-day free trial has expired"
						description="To continue using FacilityAI, please upgrade to a paid subscription."
						type="warning"
						showIcon
						style={{ marginBottom: "24px" }}
					/>

					<Paragraph>
						<Text strong>Don't lose your progress!</Text>
					</Paragraph>

					<Paragraph>
						Your account and all your data are still safe. Upgrade now to
						continue managing your facilities with FacilityAI's powerful
						features.
					</Paragraph>

					<div style={{ marginTop: "24px" }}>
						<Text type="secondary">
							Choose from our flexible pricing plans designed for organizations
							of all sizes.
						</Text>
					</div>
				</div>
			</Modal>
		</>
	);
};
